module.exports = __webpack_public_path__ + "static/media/r38.8dfb741f.webp";